import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import appSlice from "./appSlice";
import errorSlice from "./errorSlice";
import userTypeSlice from "./userTypeSlice";
import tcodeAccessSlice from "./tcodeAccessSlice";
import jdBuilderAccessSlice from "./jdBuilderAccessSlice";
import subFunctionAccessSlice from "./subFunctionAccessSlice";
import transportAdvisoryAccessSlice from "./transportAdvisoryAccessSlice";


const riwaStore = configureStore({
    reducer: {
        user: userSlice,
        app: appSlice,
        error: errorSlice,
        userType: userTypeSlice,
        tcodeAccess: tcodeAccessSlice,
        jdBuilderAccess: jdBuilderAccessSlice,
        subFunctionAccess: subFunctionAccessSlice,
        transportAdvisoryAccess: transportAdvisoryAccessSlice,
    }
});

export default riwaStore;